var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHometapLogomark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#70DBFF",
    d: "M35.099 30.668v-25.2a20.92 20.92 0 0 1 6.852 15.507c0 2.453-.428 4.802-1.2 6.99l.001.003-.003.001a21.004 21.004 0 0 1-5.65 8.513v-5.814zm-28.247 0v-25.2A20.92 20.92 0 0 0 0 20.975c0 2.453.427 4.802 1.2 6.99l-.002.003.004.001a21.004 21.004 0 0 0 5.65 8.513v-5.814z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25BE8A",
    d: "M35.099 30.668h-.002c-4.466 2.133-9.294 3.898-14.122 3.898-4.828 0-9.656-1.765-14.122-3.898h-.001l-5.65-2.699a21 21 0 0 0 5.65 8.513 20.964 20.964 0 0 0 28.247 0 21.004 21.004 0 0 0 5.65-8.512l-5.65 2.698z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70DBFF",
    d: "M2.708 24.806l.589.832 3.555 5.029V16.13l-4.144 8.675zm4.144-8.676L0 20.975l2.708 3.831 4.144-8.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25BE8A",
    d: "M6.852 30.666l-3.555-5.029-.589-.83-1.507 3.157-.003.004.004.001 5.65 2.698z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70DBFF",
    d: "M38.28 26.166l.962-1.36-4.143-8.676v14.536z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25BE8A",
    d: "M39.242 24.806l-.96 1.36-3.183 4.5v.002l5.65-2.698.003-.002-.002-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70DBFF",
    d: "M35.099 16.13l4.143 8.676 2.709-3.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25BE8A",
    d: "M39.242 24.806l1.509 3.159a20.94 20.94 0 0 0 1.2-6.989l-2.71 3.83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B770FF",
    d: "M35.099 5.468A20.961 20.961 0 0 0 20.976 0c-2.453 0-4.805.425-6.992 1.198l6.991 4.944 2.653 1.877 11.47 8.111 6.852 4.845a20.92 20.92 0 0 0-6.852-15.507"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#823BFF",
    d: "M41.95 20.976a20.92 20.92 0 0 0-6.852-15.508v10.663l6.852 4.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7070FF",
    d: "M20.975 0A20.958 20.958 0 0 0 6.853 5.468 20.915 20.915 0 0 0 0 20.975l6.851-4.845 14.124-9.987 6.992-4.944A20.936 20.936 0 0 0 20.975 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C4CFF",
    d: "M6.852 16.13V5.468A20.92 20.92 0 0 0 0 20.975l6.852-4.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A45FF",
    d: "M27.968 1.198A20.936 20.936 0 0 0 20.974 0c-2.452 0-4.804.425-6.991 1.198l6.991 4.944 6.992-4.944h.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E4DE9",
    d: "M18.406 36.186l-2.569-1.227 2.569 1.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70DD7D",
    d: "M35.097 30.668l-8.984 4.29-5.138 2.455 6.992 3.339 4.096-5.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25BE8A",
    d: "M35.099 30.668h-.002l-3.034 4.29-4.096 5.794a20.961 20.961 0 0 0 7.132-4.27v-5.814zm0 0v5.814a21.004 21.004 0 0 0 5.65-8.512l-5.65 2.698z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70DD7D",
    d: "M20.975 37.413l-2.57-1.227-2.568-1.227-8.983-4.29 3.033 4.29 4.097 5.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25BE8A",
    d: "M6.854 30.668h-.002v5.814a20.963 20.963 0 0 0 7.131 4.27l-4.096-5.793-3.034-4.29zm-.002 0l-5.65-2.699a21 21 0 0 0 5.65 8.513v-5.814z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52D457",
    d: "M13.984 40.752c2.245.795 4.61 1.2 6.991 1.199 2.453 0 4.804-.425 6.992-1.199l-6.992-3.339-6.991 3.339z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFEEC9",
    d: "M20.975 33.867a32.76 32.76 0 0 1-14.122-3.199l8.985 4.291 2.568 1.227 2.57 1.227 6.197-2.96 7.924-3.785a32.761 32.761 0 0 1-14.122 3.199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25BE8A",
    d: "M2.708 24.806l-2.707-3.83c0 2.452.426 4.802 1.2 6.989l1.507-3.158"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHometapLogomark);
export default __webpack_public_path__ + "static/media/hometap-logomark.adcecec67be261657bc741e10e173ef0.svg";
export { ForwardRef as ReactComponent };